import { render } from "./InfoCliente.vue?vue&type=template&id=0c5b4bdd"
import script from "./InfoCliente.vue?vue&type=script&lang=js"
export * from "./InfoCliente.vue?vue&type=script&lang=js"

import "./InfoCliente.vue?vue&type=style&index=0&id=0c5b4bdd&lang=scss"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__